;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import styles from './Handling.module.scss';

const richTextOverrides = {
    renderNode: {
        [BLOCKS.UL_LIST]: (node, children) => {
            return <ul className={styles.list}>{children}</ul>;
        },
        [BLOCKS.LIST_ITEM]: (node, children) => {
            return <li className={styles.listItem}>{children}</li>;
        },
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    baseTheme="headingSmall"
                    themes={{ large: 'headingMedium' }}
                >
                    <span
                        dangerouslySetInnerHTML={{
                            __html: children,
                        }}
                    />
                </Text>
            );
        },
    },
};

const Handling = ({ handling }) => {
    return (
        <div className={styles.root}>
            <RichText richText={handling} overrides={richTextOverrides} />
        </div>
    );
};

Handling.propTypes = {
    handling: PropTypes.object.isRequired,
};

export default Handling;
